<template>
    <div :class="{'w-screen h-screen relative': filteredShow}">
      <transition name="fade">
        <div
            class="h-screen w-screen fixed top-0 backdrop-filter backdrop-blur-xs bg-grey-3 left-0 z-60"
            @click="close"
            v-if="filteredShow"
        >
        </div>
      </transition>
      <transition name="slide-from-right">
        <div class="bg-white px-6 py-8 h-screen w-screen md:w-screen-1/3 fixed right-0 md:top-0 bottom-0 z-70" v-if="filteredShow" style="max-width: 30rem; margin-bottom: var(--sab)">
          <div class="flex justify-between">
            <div v-html="title" class="text-grey-2 text-left font-bold text-lg mb-6 mr-3"></div>
            <div class="cursor-pointer mt-1">
              <img src="@/assets/svg/cross.svg" alt="" @click="close" />
            </div>
          </div>
          <div v-html="content" class="overflow-y-auto text-left md:pr-4 mb-8" style="height: -webkit-fill-available" v-if="content"></div>
          <div class="overflow-y-auto md:pr-4">
            <slot name="component"></slot>
          </div>
        </div>
      </transition>
    </div>
  </template>
  <script type="ts">
  import {computed, defineComponent, onMounted, ref} from "vue";
  
  export default defineComponent({
    props:{
      show: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      content: {
        type: String
      }
    },
    emits: ['close'],
    setup(props, {emit}){
      const mounted = ref(false)
      const filteredShow = computed(() =>{
        return mounted.value && props.show
      })
      const close = () => {
        emit('close')
      }
  
      onMounted(() =>{
        setTimeout(function() {
          mounted.value = true
        }, 1);
      })
  
      return {
        close,
        filteredShow
      }
    }
  })
  
  </script>
  <style scoped>
  .slide-from-right-enter-active,
  .slide-from-right-leave-active {
    transition: all 0.2s ease-in-out;
  }
  
  @media (min-width: 768px) {
    .slide-from-right-enter-from,
    .slide-from-right-leave-to {
      right: -40rem;
    }
  }
  
  @media (max-width: 768px) {
    .slide-from-right-enter-from,
    .slide-from-right-leave-to {
      bottom: -50rem;
    }
  }
  
  </style>